import { render } from "./teams.vue?vue&type=template&id=6735d967&scoped=true"
import script from "./teams.vue?vue&type=script&lang=js"
export * from "./teams.vue?vue&type=script&lang=js"

import "./teams.vue?vue&type=style&index=0&id=6735d967&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6735d967"]])

export default __exports__